export enum StorageType {
	ACCESS_TOKEN = 'accessToken',
	ACCESS_TOKEN_OBJECT = 'accessTokenObject',
}

export function setStorageData(name: StorageType, value: string) {
	sessionStorage.setItem(name, JSON.stringify(value));
}

export function getStorageData(name: StorageType) {
	return JSON.parse(sessionStorage.getItem(name) as string);
}

export function removeStorageData(name: StorageType) {
	sessionStorage.removeItem(name);
}
